import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
  
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  // production
  private apiUrl = environment.analyticsApiUrl;
  
  constructor(private http: HttpClient) {}

   async getAnalyticsData(token: string, body: {}):  Promise<any>  {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,  // OAuth2 token for authorization
      'Content-Type': 'application/json'
    });   

    try {
      const response = await this.http.post(this.apiUrl, body, { headers }).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching analytics data:', error);
      throw error; 
    }
  }

}
